<div fxLayout="row" fxLayoutAlign="center center" class="footer">
    <div fxLayout="row" fxLayoutAlign="center center" class="container text-center secondary-text-color"> 
        <span class="mx-2">Copyright © {{any}} Todos los derechos reservados. Creado por Alfonso Pardo </span>
    </div>                
</div>